import { FileMetadata, Layer, Quote } from 'types';

export function sortLayersByAttachmentPoint(items: Layer[]) {
  return [...items].sort((a, b) => {
    if (typeof a.attachmentPoint === 'undefined') {
      return -1;
    }
    if (typeof b.attachmentPoint === 'undefined') {
      return 1;
    }
    if (a.attachmentPoint === b.attachmentPoint) {
      return 0;
    }
    return a.attachmentPoint! < b.attachmentPoint! ? -1 : 1;
  });
}

export function sortSelectedQuoteByAttachmentPoint(items: Quote[]) {
  return [...items].sort((a, b) => {
    if (typeof a.layer?.attachmentPoint === 'undefined') {
      return 1;
    }
    if (typeof b.layer?.attachmentPoint === 'undefined') {
      return -1;
    }
    if (a.layer?.attachmentPoint === b.layer?.attachmentPoint) {
      return 0;
    }
    return a.layer?.attachmentPoint! < b.layer?.attachmentPoint! ? 1 : -1;
  });
}

interface ItemWithDateField {
  date: Date;
}

export function sortByDate<T extends ItemWithDateField>(items: T[]): T[] {
  return [...items].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export const sortBySyncRequested = (a?: FileMetadata) => {
  if (a?.syncRequestDate && !a?.syncedDate) {
    return -1;
  }
  return 1;
};

// Helper function for creating string sorters that put empty values last
export const sortByStringWithEmptyLast =
  <T>(getValue: (item: T) => string | null | undefined, isDescending = false) =>
  (a: T, b: T) => {
    const aHasValue = Boolean(getValue(a)?.trim());
    const bHasValue = Boolean(getValue(b)?.trim());

    // If one has a value and the other doesn't, put the one without value last
    if (aHasValue && !bHasValue) {
      return -1;
    }
    if (!aHasValue && bHasValue) {
      return 1;
    }

    // If both have values, sort alphabetically
    if (aHasValue && bHasValue) {
      const aValue = getValue(a)!;
      const bValue = getValue(b)!;
      return isDescending ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
    }

    // If both are empty, maintain order
    return 0;
  };
